module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e35418134f3ccf0992dae078ad213084.png";